(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("uuid"), require("point-in-polygon"), require("earcut"), require("simple-quadtree"));
	else if(typeof define === 'function' && define.amd)
		define(["uuid", "point-in-polygon", "earcut", "simple-quadtree"], factory);
	else if(typeof exports === 'object')
		exports["nav2d"] = factory(require("uuid"), require("point-in-polygon"), require("earcut"), require("simple-quadtree"));
	else
		root["nav2d"] = factory(root["uuid"], root["point-in-polygon"], root["earcut"], root["simple-quadtree"]);
})((typeof self !== 'undefined' ? self : this), (__WEBPACK_EXTERNAL_MODULE__592__, __WEBPACK_EXTERNAL_MODULE__100__, __WEBPACK_EXTERNAL_MODULE__651__, __WEBPACK_EXTERNAL_MODULE__395__) => {
return 